import { useContext,useEffect } from 'react';
import { useTranslation } from "react-i18next";
import ChangeAlert from '../components/ChangeAlert/ChangeAlert';
import CustomerTabs from '../components/Customer/CustomerTabs';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar';
import { UserContext } from '../context/UserContext';
import { trackEventMatomoVisit } from '../helpers/matomo';
import { HeaderText } from '../StyledComponents/pages/pages';
import { Container,SubContainer } from './Styles';

export default function Clients() {
  const { t } = useTranslation('translation');
  const { changed, hierarchyLabel } = useContext(UserContext);

  useEffect(() => {
    trackEventMatomoVisit('Gestão de clientes');
  }, []);

  return (
    <Container>
      <Sidebar />
      <SubContainer>
        {changed && <ChangeAlert />}
        <Header />
        <HeaderText style={{ textAlign: 'center' }}>{t('customerPage.customerManagement') + ' ' + hierarchyLabel.cliente}</HeaderText>
        <div style={{
          marginBottom: '50px',
          padding: `${window.innerWidth < 800 ? '0px 2% 0px 2%' : '0px 10% 0px 10%'}`,
        }}>
          <CustomerTabs />
        </div>
        <Footer />
      </SubContainer>
    </Container>
  );
}